export enum InAppNotificationType {
  GAME_REMINDER = 'game_reminder',
  REPORT_READY = 'report_ready',
  FEEDBACK_READY = 'feedback_ready',
  /** A facilitator sent the player's team to the page of an activity: followed by the app, never listed. */
  SENT_TO_ACTIVITY = 'sent_to_activity'
}
